import React, { useEffect, useState } from 'react';
import { AutoCompleteSelectUI, ButtonUI, DialogUI, FormLabelUI, InputUI } from '../../Interface';
import { Box } from '@mui/material';
import { add } from 'mathjs';
import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';

const OpWidgetQuantityDialog = ({
  open,
  handleClose,
  handleFinishOperation,
  handleInterruptOperation,
  mode,
  autoCompleteOptions,
  data,
  helperData,
}) => {
  const defValues = {
    quantity: '',
    scrapQuantity: '',
    scrapReasonId: null,
    doseNumber: '',
  };

  const [values, setValues] = useState(defValues);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    if (!open) {
      setValues(defValues);
      setClicked(false);
    }
  }, [open]);

  const handleClick = () => {
    if (clicked) return;
    setClicked(true);

    if (mode === 'interrupt') {
      handleInterruptOperation(null, values);
    } else {
      if (add(Number(values.quantity || 0), Number(values.scrapQuantity || 0)) != Number(data.productionQuantity)) {
        setClicked(false);
        addNotification({
          type: NotificationType.ERROR,
          content: 'A lejelenteni kívánt mennyiség eltér a gyártandó mennyiségtől!',
        });
        return;
      }

      handleFinishOperation(values);
    }

    setTimeout(() => setClicked(false), 1000);
  };

  const showDoseNumberField = helperData?.operations?.find(
    (operation) => operation.operationId === data.operationId
  )?.showDoseNumber;

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Mennyiségek megadása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '750px',
          },
        },
      }}
    >
      <Box display="flex" mt="1.5rem" gap="1rem">
        <InputUI
          label={<FormLabelUI text="Jó mennyiség" />}
          type="number"
          onChange={(e) =>
            setValues((prev) => ({
              ...prev,
              quantity: e.target.value,
            }))
          }
        />
        <InputUI
          label={<FormLabelUI text="Selejt mennyiség" />}
          type="number"
          onChange={(e) =>
            setValues((prev) => ({
              ...prev,
              scrapQuantity: e.target.value,
            }))
          }
        />
        <AutoCompleteSelectUI
          label={<FormLabelUI text="Selejt ok" />}
          onChange={(_e, newVal, reason) => {
            if (reason === 'clear') {
              setValues((prevState) => ({
                ...prevState,
                scrapReasonId: '',
              }));
            } else {
              setValues((prevState) => ({
                ...prevState,
                scrapReasonId: newVal.value,
              }));
            }
          }}
          selectedValue={values?.scrapReasonId}
          variant="outlined"
          dataset={autoCompleteOptions.scrap}
        />
        {showDoseNumberField && (
          <InputUI
            label={<FormLabelUI text="Adagszám" />}
            onChange={(e) =>
              setValues((prev) => ({
                ...prev,
                doseNumber: e.target.value,
              }))
            }
          />
        )}
      </Box>
      <Box textAlign="center" mt="2rem">
        <ButtonUI text="Rögzítés" className="bg-success" onClick={() => handleClick()} />
      </Box>
    </DialogUI>
  );
};

export default OpWidgetQuantityDialog;
